import script from "./ClubInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./ClubInfo.vue?vue&type=script&setup=true&lang=js"

import "./ClubInfo.vue?vue&type=style&index=0&id=06179af9&scoped=true&lang=scss"

import exportComponent from "/Users/vixfs/PhpstormProjects/fitbase/frontend/web/vue-resources/personal-account/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06179af9"]])

export default __exports__